import React from "react";
import "../css/CareerHero.css";
import { Link } from "react-router-dom";

const discHero = () => {
  return (
    <div className="career-hero-container">
      <div className="hero-overlay-content">
        <div className="career-hero-content">
          <h1>Mandatory Public Disclosure</h1>
          <p>Join a passionate team shaping the future of education</p>
  <Link to="/career" className="btn btn-primary">
  Explore Jobs
</Link>
        </div>
      </div>
    </div>
  );
};

export default discHero;
